import "./loading.scss";

interface LoadingProps<T> {
    isLoading: boolean;
    error: any;
    data: T | null | undefined;
    children: (data: T) => React.ReactNode;
}

export default function Loading<T>({isLoading, error, data, children}: LoadingProps<T>) {
    if (isLoading){
        return <div>loading...</div>
    }

    if (error){
        return <div>error</div>
    }

    if (!data){
        return <div>No data</div>
    }

    return <>{children(data)}</>
}